"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSyncPageForValue = exports.useDynamicPageSize = exports.getMonthsForRange = exports.getDatesForRange = exports.getDatesForPage = void 0;
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getDatesForRange = function getDatesForRange(min, max, pageSize) {
  // Add 1 because range should be inclusive
  var minDatesCount = max.diff(min, 'day') + 1;
  // Round up to the nearest multiple of pageSize to ensure we fill up all pages
  var totalDates = (0, _lodash.ceil)(minDatesCount / pageSize) * pageSize;
  return (0, _lodash.range)(totalDates).map(function (i) {
    return (0, _momentTimezone.default)(min).add(i, 'days').startOf('day');
  });
};
exports.getDatesForRange = getDatesForRange;
var getDatesForPage = function getDatesForPage(allDates, page, pageSize) {
  return allDates.slice(page * pageSize, (page + 1) * pageSize);
};
exports.getDatesForPage = getDatesForPage;
var getMonthsForRange = function getMonthsForRange(min, max) {
  var interim = min.clone();
  var months = [];
  while (max > interim || interim.month() === max.month()) {
    months.push(interim.month());
    interim.add(1, 'month');
  }
  return months;
};
exports.getMonthsForRange = getMonthsForRange;
var useDynamicPageSize = function useDynamicPageSize(_ref) {
  var value = _ref.value,
    pageSize = _ref.pageSize,
    viewableDates = _ref.viewableDates,
    onPageChange = _ref.onPageChange;
  (0, _react.useEffect)(function () {
    if (!value) {
      onPageChange(0, 'start');
      return;
    }
    var selectedDateIndex = (0, _lodash.findIndex)(viewableDates, function (date) {
      return date.isSame(value, 'day');
    });
    var pageWithSelectedDate = (0, _lodash.floor)(selectedDateIndex / pageSize);
    onPageChange(pageWithSelectedDate);
  }, [pageSize]);
};
exports.useDynamicPageSize = useDynamicPageSize;
var useSyncPageForValue = function useSyncPageForValue(_ref2) {
  var value = _ref2.value,
    pageSize = _ref2.pageSize,
    viewableDates = _ref2.viewableDates,
    currentPage = _ref2.currentPage,
    onUnavailable = _ref2.onUnavailable,
    onPageChange = _ref2.onPageChange;
  (0, _react.useEffect)(function () {
    if (!value) {
      return;
    }
    var selectedDateIndex = (0, _lodash.findIndex)(viewableDates, function (date) {
      return date.isSame(value, 'day');
    });
    if (selectedDateIndex === -1) {
      onUnavailable();
      return;
    }
    var pageWithSelectedDate = (0, _lodash.floor)(selectedDateIndex / pageSize);
    if (pageWithSelectedDate !== currentPage) {
      onPageChange(pageWithSelectedDate);
    }
  }, [value]);
};
exports.useSyncPageForValue = useSyncPageForValue;